// removed by extract-text-webpack-plugin
module.exports = {"BodyText":"_2863QHdBzj_66J-xZYo3IS","Title":"_3LW3qj5sdbNsSU3kjlKv4s","IsReadTitle":"_2idRp9ucjckaaobjrHigKr","QuestionTitle":"_1JnHC26_IyIU5w23P-MKXc","Header":"_10g-SnymEAtNG9i49UdYHc","IsReadBodyText":"_3QigK3Us_jlUECiwfMYrhm","PostBox":"d6kRrY9EcPVHRQ94BDgDw","PostBlock":"_3oewWkZvzlQVSXk5RXagJF","PostContainer":"it9ZUcWaqVd0Mb9kLAWwH","Date":"_9R7ZL4GEIQRO_iADhtMig","OptionsWrapper":"cb_vvj4BxIcQddprQccqw","Options":"_2WIyZKbKbkgEuzY28YpZW6","BorderBox":"kEjBlvYIXdz8GG_SGAvte"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Helpdesk/Feedback/Posts/Post/style.css
// module id = 2038
// module chunks = 0